import { useEffect, useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import './Footer.css';

const Footer = () => {
  const [version, setVersion] = useState('');

  useEffect(() => {
    // Get version from WordPress localized data
    if (window.HavenlyticsData?.version) {
      setVersion(window.HavenlyticsData.version);
    } else if (window.hvnlyNabAdmin?.version) {
      setVersion(window.hvnlyNabAdmin.version);
    } else {
      // Fallback to fetching from API
      fetchVersion();
    }
  }, []);

  const fetchVersion = async () => {
    try {
      const response = await fetch('/wp-json/hvnlynab/v1/plugin-info');
      const data = await response.json();
      if (data.version) {
        setVersion(data.version);
      }
    } catch (error) {
      console.error('Failed to fetch version:', error);
    }
  };

  return (
    <footer className="hvnly-settings-api__footer">
      <div className="hvnly-settings-api__version">
        {__('Havenlytics', 'havenlytics')} {version && `v${version}`}
      </div>
      <div className="hvnly-settings-api__footer-links">
        <a target='_blank' href="https://havenlytics.com/documentation/" className="hvnly-settings-api__footer-link">
          <i className="fas fa-book"></i> {__('Documentation', 'havenlytics')}
        </a>
        <a target='_blank' href="https://wordpress.org/support/plugin/havenlytics/" className="hvnly-settings-api__footer-link">
          <i className="fas fa-question-circle"></i> {__('Supports', 'havenlytics')}
        </a>
        <a target='_blank' href="https://github.com/havenlytics/havenlytics" className="hvnly-settings-api__footer-link">
          <i className="fas fa-bug"></i> {__('Report Issue', 'havenlytics')}
        </a>
      </div>
    </footer>
  );
};

export default Footer;